import { css } from '@emotion/react';
import React from 'react';

import { BillingCycle } from '$/GraphQL/schema/schema';

import { StyleProps } from '$/components/ui';

import { usePlanPageContext } from '../PlanPage';

export const PlanTable: React.FC<React.PropsWithChildren<StyleProps>> = ({
  children,
  className,
}) => {
  const { billingCycle, subscriptionInfo } = usePlanPageContext();
  return (
    <table
      className={`table-fixed w-full ${className}`}
      css={css`
        & tr {
          td,
          th {
            vertical-align: top;
            padding: 0.5rem;
            @media screen and (min-width: 920px) {
              padding: 0.25rem 0.5rem;
            }
            &:nth-of-type(${billingCycle === BillingCycle.Month ? 2 : 3}) {
              background-color: #f8f8f8;
            }
            &:nth-of-type(${billingCycle === BillingCycle.Month ? 3 : 2}) {
              opacity: 0.75;
              display: none;
              @media screen and (min-width: 920px) {
                display: table-cell;
              }
            }
            &:nth-of-type(${subscriptionInfo.billingCycle === BillingCycle.Month ? 3 : 2}) {
              .add-on-button {
                display: none;
              }
            }
            ${subscriptionInfo.isLegacyTeam
              ? `
                &.price {
                  @media screen and (min-width: 920px) {
                    width: 22rem !important;
                  }
                }
                &:nth-of-type(3) {
                  display: none !important;
                }
              `
              : ``}
          }
          td.price {
            width: 11rem;
            text-align: center;

            + td {
              text-align: center;
            }
          }
          &:nth-of-type(2) {
            td,
            th {
              opacity: 1;
              padding: 1rem 0.5rem;
              border-radius: 0.5rem 0.5rem 0 0;
            }
          }
        }
      `}
    >
      <tbody>{children}</tbody>
    </table>
  );
};
